<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    x="0"
    y="0"
    :class="[size]"
    viewBox="0 0 96 68"
    xml:space="preserve"
  >
    <g id="Group_5" transform="translate(.294)">
      <g id="Group_4">
        <path
          class="st0"
          d="M89.58 68.18h-83c-3.54 0-6.43-2.89-6.43-6.43V2.48A2.48 2.48 0 0 1 2.63 0h90.89A2.48 2.48 0 0 1 96 2.48v59.28c0 3.53-2.88 6.42-6.42 6.42zM5.11 4.96v56.8c0 .81.66 1.47 1.47 1.47h82.98c.81 0 1.47-.66 1.47-1.47V4.96H5.11z"
          transform="translate(-.294)"
        />
        <path
          class="st0"
          d="M48.08 39.46c-1.4 0-2.79-.46-3.96-1.37L1.1 4.43C.27 3.78-.06 2.67.29 1.67S1.57 0 2.63 0h90.89a2.476 2.476 0 0 1 1.52 4.43l-43 33.66a6.412 6.412 0 0 1-3.96 1.37zm-.91-5.27c.53.42 1.28.42 1.82 0L86.33 4.96H9.82l37.35 29.23z"
          transform="translate(-.294)"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "MessageIcon",
  props: {
    size: {
      type: String,
      default: "medium",
      validator: function (value) {
        // The value must match one of these strings
        return ["small", "medium", "large", "xlarge", "xxlarge"].includes(
          value
        );
      },
    },
  },
};
</script>

<style scoped>
.st0 {
  fill: #619bc4;
}
.medium {
  height: 24px;
  width: auto;
}
.large {
  height: 60px;
  width: auto;
}

.xlarge {
  height: 74px;
  width: auto;
}

.xxlarge {
  height: 84px;
  width: auto;
}

.xxlarge--mail {
  margin-top: 10px;
  height: 74px;
  width: auto;
}
</style>
